import type { PaymentFormTheme } from '~/helpers/paymentFormTheme';

// The legacy palette, kept in sync with app/assets/styles/base.css.
export const paymentFormTheme: PaymentFormTheme = {
  depth: ['#262f37', '#2d3843', '#32404d', '#364757'],
  accent: '#50fcea',
  accentHover: '#3acec0',
  onAccent: '#0c1116',
  accentWash: {
    hover: 'rgba(80, 252, 234, 0.05)',
    open: 'rgba(80, 252, 234, 0.1)',
  },
  text: '#dddddd',
  mutedText: '#99b5d0',
  errorText: '#ff3954',
  field: { background: '#262f37', border: '#364757' },
  fontFamily: '"Source Sans Pro", Arial, Helvetica, sans-serif',
  buttonLabel: { textTransform: 'uppercase', letterSpacing: '0.05em' },
  chargebee: { rules: {} },
  stripeAppearance: {
    // Stripe's default white reads as a broken embed on a dark panel.
    theme: 'night',
    variables: {
      colorBackground: '#262f37',
      colorText: '#e6e9ec',
      borderRadius: '8px',
    },
  },
};
